import {
  failureAction, successAction, startAction,
} from '../../common'
import { GET_ISSUES_DONE } from '../types'

export const initialState = {
  loading: false,
  loaded: false,
  error: {},
  data: {
    numResults: 0,
    docs: [],
  },
}

const reducer = ({ done: state }, action) => {
  switch (action.type) {
    case startAction(GET_ISSUES_DONE):
      return {
        ...initialState,
        loading: true,
        loaded: false,
      }
    case successAction(GET_ISSUES_DONE):
      return {
        ...state,
        loading: false,
        loaded: true,
        error: {},
        data: action.payload,
      }
    case failureAction(GET_ISSUES_DONE):
      return {
        ...initialState,
        error: action.payload,
      }

    default:
      return state
  }
}

export default reducer
